export const BefitisData = [
  {
    heading: "Terminology Consistency",
    para: "We use the latest translation tools to keep your translations consistent. Our experts are versed in the specialized terminologies for your translations, and can work with your own glossaries, as well.",
    img_link: "",
  },
  {
    heading: "Highly-qualified technical translators",
    para: "We primarily account for two things whenever we're hiring translators. First, we deploy translators who have the linguistic expertise, as well as industry expertise for your translations.",
    img_link: "",
  },
  {
    heading: "A Database of Insights",
    para: "We are consistently working with companies from virtually all industries. Thus, our translation tech team is constantly updating and expanding our database of technical terminologies.",
    img_link: "",
  },
];

export const VariousTranslationData = [
  {
    title: "Engineering",
    detail:
      "For engineering, whether in electrical or mechanical, software or hardware, there's a demand for exacting technical translation of diverse documentation, marketing materials, and reports. Tomedes brings to your next translation projects the engineering specialization to ensure that nothing is lost in translation.",
  },
  {
    title: "Natural Sciences",
    detail:
      "Natural sciences require exact technical translation to convey across languages the nuances of biology, chemistry, and other scientific documents, in academic as well as industrial settings. Tomedes brings to each project a team of senior linguists trained in the required language pairs and commanding the terminology of each specific domain.",
  },
  {
    title: "Applied Mathematics",
    detail:
      "Math may contain numbers, but the surrounding text also matters. Technical language translation is an essential complement to numerical computation and documentation. You can count on Tomedes to hand-pick the technical translators who know the nuances of mathematical language and can render that linguistic expertise across the specific language pair and terminology required.",
  },
  {
    title: "Agricultural Sciences",
    detail:
      "Agricultural science demands precise technical translation to convey across borders the detailed documentation needed to grow and harvest crops properly. Tomedes has worked with clients around the world in fields of agritech, irrigation technology, and related fields, preparing documents intended for diverse audiences from scientists to hands-on farmers.",
  },
  {
    title: "Social Sciences",
    detail:
      "Social sciences are called “soft” in relation to natural sciences, but accurate technical translation is indispensable for psychological, sociological, and political sciences. There's nothing soft about the seriousness which Tomedes brings to each project: we ensure that an expert team of linguists familiar with both the language pair and the social scientific domain will fulfill your translation needs.",
  },
];
